import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { OrderResponse } from './OrderResponse';
export class ActiveRealTimeOrderResponse {
    constructor(order) {
        this.order = order;
    }
}
__decorate([
    Type(() => OrderResponse),
    __metadata("design:type", Object)
], ActiveRealTimeOrderResponse.prototype, "order", void 0);
